import React from 'react'

export default class Body extends React.Component {
  render() {
    return (
      <div className='table-body'>{this.props.children}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Table/Body.js